import React, {memo} from 'react';
import dynamic from 'next/dynamic';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'), {ssr: false});
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {spacing} from '@/styles/tokens';

const imageBannerBoxSx = {position: 'relative', width: 150, height: 60} as const;
const imageBannerStyle: React.CSSProperties = {objectFit: 'contain'};

const sxBannerSubImages = {
    filter: 'grayscale(1)',
    height: 'auto',
    padding: `0 ${spacing[16]}`,
    '&:hover': {
        filter: 'grayscale(0)'
    }
} as const;

const BannerBottom = (props: any) => {
    const {bannerData, className, ourPartner, partnerContent, isStatic, colorful} = props;

    if (isStatic) {
        // Deduplicate by alt since the data is pre-doubled for the marquee
        const unique =
            bannerData?.filter((item: any, idx: number, arr: any[]) => arr.findIndex((t: any) => t.alt === item.alt) === idx) ?? [];

        return (
            <Box className="sub-banner-wrapper">
                <MUIContainer>
                    <Box display="flex" alignItems="center" gap={2} py={1}>
                        {partnerContent && (
                            <Typography
                                mr={2}
                                fontWeight="bold"
                                sx={{flex: '0 0 auto', whiteSpace: 'nowrap'}}
                                fontSize={20}
                                className="font-headers"
                            >
                                {partnerContent}
                            </Typography>
                        )}
                        <Box display="flex" alignItems="center" justifyContent="space-evenly" flexWrap="wrap" gap={2} flex={1}>
                            {unique.map((data: any, index: number) => (
                                <Box key={index} className="images-banner-bottom" sx={imageBannerBoxSx}>
                                    <Box
                                        component={DisplayImage}
                                        src={data.src}
                                        alt={data.alt}
                                        fill
                                        sizes="120px"
                                        style={colorful ? {objectFit: 'contain', padding: '0 16px'} : imageBannerStyle}
                                        sx={colorful ? undefined : sxBannerSubImages}
                                    />
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </MUIContainer>
            </Box>
        );
    }

    return (
        <Box className="sub-banner-wrapper">
            <MUIContainer>
                <Box display="flex" alignItems="center" overflow="hidden">
                    {!ourPartner && (
                        <Typography mr={4} fontWeight="bold" sx={{flex: 1, whiteSpace: 'nowrap'}} fontSize={20} className="font-headers">
                            {partnerContent}
                        </Typography>
                    )}

                    <Box className="banner-bottom-container-wrapper">
                        <Box display="flex" gap={4} className={`banner-bottom-container ${className}`}>
                            {bannerData?.map((data: any, index: number) => (
                                <Box key={index}>
                                    <Box className="images-banner-bottom" sx={imageBannerBoxSx}>
                                        <Box
                                            component={DisplayImage}
                                            src={data.src}
                                            alt={data.alt}
                                            fill
                                            sizes="140px"
                                            style={imageBannerStyle}
                                            sx={sxBannerSubImages}
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        <Box display="flex" gap={4} className={`banner-bottom-container ${className}`} aria-hidden="true">
                            {bannerData?.map((data: any, index: number) => (
                                <Box key={`duplicate-${index}`}>
                                    <Box className="images-banner-bottom" sx={imageBannerBoxSx}>
                                        <Box
                                            component={DisplayImage}
                                            src={data.src}
                                            alt={data.alt}
                                            fill
                                            sizes="140px"
                                            style={imageBannerStyle}
                                            sx={sxBannerSubImages}
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </MUIContainer>
        </Box>
    );
};

export default memo(BannerBottom);
